import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AssetPipes } from 'src/app/shared/pipes/asset.pipe';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-asset-filter',
  templateUrl: './asset-filter.component.html',
  styleUrls: ['./asset-filter.component.scss']
})
export class AssetFilterComponent implements OnInit, OnChanges {

  @Input() selectedService;
  @Input() case;
  @Input() assets;

  @Output() assetSelected = new EventEmitter();

  public filteredAssets = [];
  public vendor = '';
  public vendors = [];
  public vendorSearch = '';
  public assetPipe: AssetPipes = new AssetPipes();
  public assetFilter = new AssetFilter('', '');

  constructor(
    private alertService: AlertService
  ) { }

  ngOnInit(): void {

    this.filteredAssets = this.assets;
    this.extractVendors();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.assets) {
      this.applyFilter();
    }
  }

  public applyFilter() {
    if(this.assets) {
      this.filteredAssets = this.assetPipe.transform(this.assets, this.assetFilter);
    }
  }

  public updateAsset(asset) {
    //if selected send the value, if deselected, send null
    this.assetSelected.emit(asset);
  }

  /**
   * get selected asset display name
   */
  public selectedAssetDisplayName(): string {
    if (this.case.assetId === undefined) {
      this.alertService.handlerError('no Asset selected');
      return 'No asset selected';
    }
    else {
      const selectedAsset = this.assets.find(a => a.id === this.case.assetId);
      if (selectedAsset) {
        const fields = [];
        if (selectedAsset.vendor) {
          fields.push(selectedAsset.vendor);
        }
        if (selectedAsset.model) {
          fields.push(selectedAsset.model);
        }
        if (selectedAsset.name) {
          fields.push(selectedAsset.name);
        }
        if (selectedAsset.serialNumber) {
          fields.push(selectedAsset.serialNumber);
        }
        return fields.join(' | ');
      }
      else {
        this.alertService.handlerError('Selected asset not in asset list');
        return 'Selected asset not in asset list';
      }
    }
  }

  /**
   * remove selected vendor
   */
  public removeSelectedVendor() {
    this.assetFilter.vendor = '';
    this.applyFilter();
  }

  /**
   * extract Vendors from assets cached
   */
  private extractVendors() {
    let vendors = this.filteredAssets.map(a => a.vendor);
    vendors = vendors.filter(v => v !== '');
    vendors = vendors.filter(this.onlyUnique);
    this.vendors = vendors;
  }

  /**
   * Utility to erase double from the list
   */
  private onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  public resetVendorSearch() {
    this.assetFilter.vendor = '';
    this.assetFilter.search = '';
    this.applyFilter();
  }

}

export class AssetFilter {
  vendor: string;
  search: string;

  constructor(vendor: string, search: string) {
    this.vendor = vendor;
    this.search = search;
  }
}
